import { LangLocale } from '@myre/common-i18n';
import { LANGLOCALE } from '@myre/ui-primitive-core';

import {
  inject,
  Injectable,
  NgZone,
  Renderer2,
  RendererFactory2,
} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GoogleMapsApiService {
  private readonly _zone = inject(NgZone);
  private readonly _rendererFactory = inject(RendererFactory2);
  private readonly _langLocale = inject<LangLocale>(LANGLOCALE);

  private _mapsLoading: boolean = false;
  private _mapsLoaded: boolean = false;
  private _mapsError: boolean = false;

  private readonly _renderer: Renderer2;

  constructor() {
    const _rendererFactory = this._rendererFactory;

    this._renderer = _rendererFactory.createRenderer(null, null);
  }

  public get isGoogleMapsApiLoaded(): boolean {
    return this._mapsLoaded;
  }

  public get isGoogleMapsApiLoading(): boolean {
    return this._mapsLoading;
  }

  public get isGoogleMapsApiOnError(): boolean {
    return this._mapsError;
  }

  public async initialize(googleMapsApiKey: string): Promise<void> {
    return new Promise((res, rej) => {
      if (!this._mapsLoaded && !this._mapsLoading) {
        this._mapsLoading = true;

        const render = this._renderExternalScript(
          `https://maps.googleapis.com/maps/api/js?libraries=places&key=${googleMapsApiKey}&language=${this._langLocale}`,
        );
        render.onload = () => {
          this._zone.run(() => {
            this._mapsLoading = false;
            this._mapsLoaded = true;

            return res();
          });
        };

        render.onerror = err => {
          this._zone.run(() => {
            this._mapsLoading = false;
            this._mapsLoaded = false;
            this._mapsError = true;

            return rej(err);
          });
        };
      } else {
        return res();
      }
    });
  }

  private _renderExternalScript(src: string): HTMLScriptElement {
    const script = document.createElement('script');

    script.type = 'text/javascript';
    script.src = src;
    script.async = true;
    script.defer = true;

    this._renderer.appendChild(document.body, script);

    return script;
  }
}
